export enum ContentTemplate {
  PDF = 'PDF',
  BLOG_ARTICLE = 'BLOG_ARTICLE',
  HELP_GUIDE = 'HELP_GUIDE',
  LANDING_PAGE = 'LANDING_PAGE',
  VIDEO = 'VIDEO'
}
